<template>
  <b-row v-if="$route.name === 'EXCMDeviceCreate'">
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMDeviceList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <EXCMDeviceForm
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <EXCMDeviceForm
        :openedInModal="true"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations" />
    </b-col>
  </b-row>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMDeviceForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdevice/create')

export default {
  props: {
    openedInModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EXCMDeviceForm,
    Loader
  },

  data () {
    return {
      item: {
        street: '',
        city: '',
        postcode: '',
        latitude: '',
        longitude: '',
        idDeviceModel: null,
        idContractorUserData: null
      }
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceCreate')
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (!this.openedInModal) {
        this.$Swal({
          title: created.serialNumber + ' ' + this.$t('notifications.created'),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'EXCMDeviceShow', params: { id: created['@id'] } })
      } else {
        this.$store.state.modals.excmdevice.form.close = 1
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
